import Dexie from 'dexie';
import { IPropriedade } from '../mappers/IPropriedade';
import { IAnimal } from '../modules/animals/entities/IAnimal';
import { IRegistro } from '../mappers/IRegistro';
import { IUsuario } from '../mappers/IUsuario';
import { IToPerform } from '../modules/toPerform/entities/IToPerform';
import { IFiltrosValidos } from '../mappers/IFiltrosValidos';

export class Database extends Dexie {
  propriedades: Dexie.Table<IPropriedade>;

  animais: Dexie.Table<IAnimal>;

  registros: Dexie.Table<IRegistro>;

  usuarios: Dexie.Table<IUsuario>;

  toPerform: Dexie.Table<IToPerform>;

  filtrosValidos: Dexie.Table<IFiltrosValidos>;

  animais_data =
    'id,nome,data_de_nascimento,sexo,ra_a,lote,categoria,privado,pertencente,obs,bottom_eletronico,numero_de_identificacao,mae_id,estado,pai_id,safra,propriedade_id,created_at,updated_at';

  propriedades_data =
    'id,nome,descricao,latitude,longitude,privada,proprietario_id,area_total,area_produtiva,categoria_animais,created_at,updated_at';

  constructor() {
    super('Database');
    this.version(1).stores({
      propriedades: this.propriedades_data,
      animais: this.animais_data,
      usuarios:
        'id,nome,email,avatar_url,formacao_profissional,facebook_nome,instagram_nome,youtube_link,whatsapp_numero',
      registros:
        'id,animal_id,data,categoria,descricao,rotulo,created_at,updated_at',
      toPerform: 'id,method,url,data,config,created_at,updated_at',
      filtrosValidos: 'id,data',
    });

    this.propriedades = this.table('propriedades');
    this.animais = this.table('animais');
    this.registros = this.table('registros');
    this.usuarios = this.table('usuarios');
    this.toPerform = this.table('toPerform');
    this.filtrosValidos = this.table('filtrosValidos');
  }
}
